import { configureStore } from '@reduxjs/toolkit';
import root from './rootState';

export const store = configureStore({
  reducer: {
    root: root,
  },
});
